import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { useEffect } from "react"
import { formatterDate, getNotificationLabelByValue, } from "../../../utils"
import { addDays } from "date-fns"

export function MonitoringNotifiche2023List() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const notifiche2023State = useAppSelector(state => state.notifiche2023)

    const response = [{
        region: 'Sicilia',
        headQuarters: 'SC',
        clientCode: 'B010',
        companyName: 'Bonfiglio Giovanni',
        dataIn: '2020-01-01',
        notNumber: '20438704593',
        protNumber: 'SC E00002/2020',
        notType: 'NOTIFICA DI VARIAZIONE',
        variationType: 'AUMENTO O DIMNINUZIONE DI SUPERFICIE CONDOTTA',
        notSuperata: 'NO',
        releaseDate: '2020-01-01',
        p004: '',
        inspectionVisit: "visita del 31/05/2025 Protocollo: SC E04478/2025 - del 04/06/2025",
        m29EmissionDate: '2025-05-29',
        conformity: 'SI',
        userValidation: 'Fabio Scionti',
        ridEmessa: '',
        re16: 'NO',
        M24: '',
        M29: '',
        comunicazioneOltreTermini: ''
    }]

    return (
        <div className="mt-6">
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th  style={{ borderTopLeftRadius: '8px' }}>Regione</th>
                        <th>SOT</th>
                        <th>Ciente</th>
                        <th>Cod. Op</th>
                        <th>Data Ingresso</th>
                        <th>Notifica Num.</th>
                        <th>Protocollo</th>
                        <th>Tipo Notifica</th>
                        <th>Tipo Variazione</th>
                        <th>Not. Superata</th>
                        <th>Data Rilascio</th>
                        <th>Gestione CDX P004.03</th>
                        <th>Visita Ispettiva</th>
                        <th>Termine Emissione M29</th>
                        <th>Conforme</th>
                        <th>Utente Validazione</th>
                        <th>Rid Emessa</th>
                        <th>Provvedimento Presente</th>
                        <th>M24 Associato</th>
                        <th>M29 Associato</th>
                        <th>Operaz.</th>
                        <th style={{ borderTopRightRadius: '8px' }}>Comunicazione Oltre i termini</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        response?.map((data, index) => (
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    fontSize:'14px',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td>{data.region}</td>
                                <td>{data.headQuarters}</td>
                                <td>{data.companyName}</td>
                                <td>{data.clientCode}</td>
                                <td>{formatterDate(data.dataIn)}</td>
                                <td>{data.notNumber}</td>
                                <td>{data.protNumber}</td>
                                {/* <td>{formatterDate(addDays(new Date(fs.startingDate), 90))}</td> */}
                                <td>{data.notType}</td>
                                <td>{data.variationType}</td>
                                <td>{data.notSuperata}</td>
                                <td>{data.releaseDate}</td>
                                <td>{data.p004}</td>
                                <td>{data.inspectionVisit}</td>
                                <td>{data.m29EmissionDate}</td>
                                <td>{data.conformity}</td>
                                <td>{data.userValidation}</td>
                                <td>{data.ridEmessa}</td>
                                <td>{data.re16}</td>
                                <td>{data.M24}</td>
                                <td>{data.M29}</td>
                                <td>{data.comunicazioneOltreTermini}</td>
                                <td></td>
                            </tr>
                        ))}

                </tbody>
            </table>
        </div>
    )
}